//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.ProductInterface.js";
import "../no/Object.js";
import "../no/Assemblies.js";
import "../no/Part.js";
let d=[[],[[[],"CreateObjectBuilder",{R_:{builder:"Assemblies.ProductInterface.ObjectBuilder"}},0,1],[["version"],"CreateObjectBuilderWithVersion",{R_:{builder:"Assemblies.ProductInterface.ObjectBuilder"}},1,1],[["version"],"CreateObjectBuilderWithBuilderVersion",{R_:{builder:"Assemblies.ProductInterface.ObjectBuilder"}},1,0],[[],"CreatePropertyBuilder",{R_:{builder:"Assemblies.ProductInterface.PropertyBuilder"}},0,0],[["journal_identifier"],"FindObject",{R_:{found:"NXObject"}},1,0],[["n_interface_objects"],"GetProductInterfaces",{R_:{interface_objects:"Assemblies.ProductInterface.InterfaceObject[]"}},0,0],[[],"NewGroup",{R_:{group:"TaggedObject"}},0,0],[["prodIntGroup","groupName"],"RenameGroup",{},2,0],[["prodIntGroup"],"GetGroupName",{R_:{groupName:''}},1,0],[["prodIntGroup","memberToMove"],"MoveMemberToGroup",{},2,0],[["prodIntGroup","memberToRemove"],"RemoveMemberFromGroup",{},2,0],[["prodIntGroup"],"Ungroup",{},1,0],[["prodIntGroup","deleteWithMembers"],"DeleteGroup",{},2,0],[["productInterfaceObject","selectedGroups"],"AddMemberToGroups",{},2,0]],[]];
SPLM.Assemblies.ProductInterface.Collection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Assemblies.ProductInterface.Collection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;